import { faEye, faFilePdf } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { memo, useCallback, useState } from "react";
import ViewAssignedProducts from "./ViewAssignedProducts";
import { Modal } from "react-bootstrap";
import notistack from "pages/Core/Notistack";
import { generateMayaveToStoreChalan } from "../services/po.stock.service";
import { HttpStatus } from "pages/Core";
import Loader from "Common/Loader";


export const AssignProductActionBtn = memo(({ selectedId }: { selectedId: string }) => {
    const [showDetails, setShowDetails] = useState(false);

    const handleShowDetails = () => {
        setShowDetails(true);
    }

    const [showVoucherModal, setShowVoucherModal] = useState(false);
    const [pdfData, setPdfData] = useState<any | null>(null);
    const [loadingPdf, setLoadingPdf] = useState(false);

    const getDilleveryChallan = useCallback(async () => {
        try {
            setLoadingPdf(true);
            const response = await generateMayaveToStoreChalan({ id: selectedId });
            if (response.status === HttpStatus.Success) {
                setShowVoucherModal(true);
                setPdfData(response.data.data);
            }
            else {
                notistack.notifyFromApi(response);
                setPdfData(null);
                setShowVoucherModal(false);
            }
        } catch (error: any) {
            notistack.error(error || 'Failed to fetch delivery challan.');
        } finally {
            setLoadingPdf(false);
        }
    }, [selectedId]);

    return (
        <>
            {loadingPdf && <Loader />}

            <div className='d-flex gap-1'>
                <button
                    className='btn btn-sm'
                    onClick={() => handleShowDetails()}
                    title='View details'
                >
                    <FontAwesomeIcon icon={faEye} title="View details" className="ml-2 " />
                </button>

                <button className='btn btn-sm action-btn'
                    onClick={getDilleveryChallan}
                >
                    <FontAwesomeIcon icon={faFilePdf} className="ml-2 text-danger" title="View Delivery Challan" />
                </button>
            </div>

            <ViewAssignedProducts
                isOpen={showDetails}
                onClose={() => setShowDetails(false)}
                selectedId={selectedId}
            />

            <Modal size='lg' show={showVoucherModal} onHide={() => setShowVoucherModal(false)} backdrop="static" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Delivery Challan</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {pdfData ? (
                        <iframe
                            src={`data:application/pdf;base64,${pdfData}`}
                            title="Voucher PDF"
                            width="100%"
                            height="500px"
                            style={{ border: 'none' }}
                        />
                    ) : (
                        null
                    )}
                </Modal.Body>
            </Modal>
        </>
    )
})